export default "__VITE_ASSET__ab3ca53f__"